import { Coins } from '@phosphor-icons/react'

const MINT_WASH = 'rgba(0, 212, 146, 0.06)'
const AMBER_GLOW =
  'radial-gradient(181px 44px at 50% 0%, rgba(253, 199, 0, 0.2) 0%, rgba(253, 199, 0, 0.1) 49.3%, rgba(253, 199, 0, 0) 100%)'
const AMBER_GLOW_BURN =
  'radial-gradient(220px 25px at 50% 0%, rgba(253, 199, 0, 0.06) 0%, rgba(253, 199, 0, 0.03) 49.3%, rgba(253, 199, 0, 0) 100%)'
const EMERALD_TEXT = '#007a55'

export interface GiftCardSavingsStripProps {
  /** Pre-formatted savings copy, e.g. "Saved ₹800!". */
  label: string
}

const GiftCardSavingsStrip = ({ label }: GiftCardSavingsStripProps) => {
  return (
    <div className='ui-relative ui-flex ui-w-full ui-items-center ui-justify-center ui-overflow-hidden ui-px-5 ui-py-3'>
      <div aria-hidden className='ui-pointer-events-none ui-absolute ui-inset-0'>
        <div className='ui-absolute ui-inset-0' style={{ background: AMBER_GLOW }} />
        <div className='ui-absolute ui-inset-0 ui-mix-blend-color-burn' style={{ background: AMBER_GLOW_BURN }} />
        <div className='ui-absolute ui-inset-0' style={{ backgroundColor: MINT_WASH }} />
      </div>

      <div className='ui-relative ui-flex ui-items-center ui-gap-1'>
        <Coins size={18} weight='duotone' style={{ color: EMERALD_TEXT }} />
        <p className='ui-text-text-xs-semibold' style={{ color: EMERALD_TEXT }}>
          {label}
        </p>
      </div>
    </div>
  )
}

export default GiftCardSavingsStrip
